var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-layout"},[_c('AdminHeader',{on:{"logout":_vm.handleLogout}}),_c('div',{staticClass:"admin-container"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }